module.exports = __webpack_public_path__ + "media/images/city/085-cathedral-of-morelia-1a9f9340f5505d91909f47f304ee25c9.svg";